<template>
  <!--Filters Buttons-->
  <div class="md-layout-item md-size-15">
    <md-button class="icon-button-size-40 md-icon-button icon-button"
               :class="isRaised(item)"
               :diabled="disabled">

      <md-icon v-if="item == 0 || item == 1"
               :class="isRaised(item, true)"
               class="fa fa-pencil-square-o button-icon" />
      <md-icon v-if="item == 2"
               :class="isRaised(item, true)"
               class="fa fa-check-square-o button-icon align-read-icon" />
      <md-icon v-if="item == 3"
               :class="isRaised(item, true)"
               class="fa fa-money button-icon align-money-icon" />
    </md-button>
  </div>
</template>

<script>

  export default {
    name: "ReadUnreadIcon",
    props: {
      title: {
        type: String,
        default: null
      },
      isRaised: {
        type: Function,
        reuired: true
      },
      item: {
        type: String,
        reuired: true
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {}
  };

</script>
<style src="../filters.css"></style>
